import Step from './Step';

interface CodeStepDefinition {
  code: string;
  variables?: Record<string, string>;
  condition?: string;
}

class CodeStep extends Step {
  constructor(description: string, definition: CodeStepDefinition) {
    const defaultedDefinition = {
      ...definition,
      code: definition.code || '',
      variables: definition.variables || {},
      condition: definition.condition
    };
    super("code", description, defaultedDefinition);
  }

  toJson() {
    // Ensure all required fields are present with defaults
    const definition = {
      code: this.definition.code || '',
      variables: this.definition.variables || {},
      ...(this.definition.condition ? { condition: this.definition.condition } : {})
    };

    return {
      type: 'code',
      params: {
        id: this.id,
        description: this.description,
        definition
      }
    };
  }

  static fromJson(json: any): CodeStep {
    const definition = json.params?.definition || {};
    return new CodeStep(
      json.params?.description || '',
      {
        code: definition.code || '',
        variables: definition.variables || {},
        condition: definition.condition
      }
    );
  }
}

export default CodeStep;